var render = function render(){var _vm=this,_c=_vm._self._c;return _c('extra-table',{attrs:{"title":_vm.$t('pickups'),"entity":"pickups","fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }